import React from 'react';

import { StyledEmptyState } from './styles';

export default function EmptyState({ title, subtitle, icon, style }) {
  return (
    <StyledEmptyState style={style}>
      {icon && <img src={icon} />}

      <div className='container-titles-empty-state'>
        <span className='title-empty-state'>{title}</span>
        <span className='subtitle-empty-state'>{subtitle}</span>
      </div>
    </StyledEmptyState>
  );
}
